import { EIV_ENTRY_TYPE } from 'global/constants';

const getCompanyType = (parts) => {
  if (!parts?.length) return '';
  if (parts[2] === 'H') return 'Hilfsbetrieb';
  return 'Hauptbetrieb';
};

const getBranchType = (parts) => {
  if (!parts?.length) return '';
  if (parts[0] === 'Main') return EIV_ENTRY_TYPE.MAIN;
  return EIV_ENTRY_TYPE.GUEST;
};

export const getBranchSelectionData = (branchNameEnergy, branchNameGas) => {
  const partsEnergy = branchNameEnergy.match(/[A-Z][a-z]*/g) || [];
  const partsGas = branchNameGas.match(/[A-Z][a-z]*/g) || [];
  const isEnergyActive = partsEnergy.length > 0;
  const isGasActive = partsGas.length > 0;

  return {
    isEnergyActive,
    isGasActive,
    companyTypeEnergy: isEnergyActive ? getCompanyType(partsEnergy) : '',
    companyTypeGas: isGasActive ? getCompanyType(partsGas) : '',
    branchTypeEnergy: isEnergyActive ? getBranchType(partsEnergy) : '',
    branchTypeGas: isGasActive ? getBranchType(partsGas) : '',
  };
};
